var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var SetLoginPreferences = require('./SetLoginPreferences.js');
var LoginPrefsLoading = require('./LoginPrefsLoading.js');

var {
    fetchAccessTokenFromLocal, fetchIdTokenFromLocal,
    generateAuthUrlFromConfig, readIdToken, generateAuthUrlFromConfigForSilentAuth
} = require('../../LPAuthUtils/AuthUtil');
var { fetchTokenClaims, isTokenValid, expiresAt } = require('../../LPAuthUtils/JwtUtil');
var OAuthClientConfig = require('../../LPAuthUtils/OAuthClientConfig');
var { Session } = require('../../LPAuthUtils/SessionMonitor.js');
var IFrameManager = require('../../LPAuthUtils/IFrameManager.js').default;


class LoginPreferences extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            renderloginPreference: false,
            idToken: '',
            decodedIdToken: {},
            localeId: this.props.localeId
        };

        this._iFrameManager = IFrameManager();
        this._onSilentAuthSuccess = this.onSilentAuthSuccess.bind(this);
        this._onSilentAuthError = this.onSilentAuthError.bind(this);
    }

    componentDidMount() {
        const idamClientConfig = OAuthClientConfig;
        let accessToken = fetchTokenClaims(fetchAccessTokenFromLocal());
        let idToken = fetchTokenClaims(fetchIdTokenFromLocal());
        if (!isTokenValid(accessToken) || !isTokenValid(idToken) || accessToken.userType != this.props.userType) {
            generateAuthUrlFromConfig(idamClientConfig)
                .then((authzUrl) => {
                    window.location = authzUrl;
                });
        } else {
            this.startSessionMgmt(accessToken);
        }

        window.addEventListener('onSilentAuthSuccess', this._onSilentAuthSuccess);
        window.addEventListener('onSilentAuthError', this._onSilentAuthError);

    }

    componentWillUnmount() {
        window.removeEventListener('onSilentAuthSuccess', this._onSilentAuthSuccess);
        window.removeEventListener('onSilentAuthError', this._onSilentAuthError);
    }

    startSessionMgmt(accessToken) {
        let expiresIn = expiresAt(accessToken);
        console.log('expiresAt:', expiresIn);

        Session.start('sessionLP', {
            expiration: expiresIn
        });

        this.setState({
            idToken: fetchAccessTokenFromLocal(),
            decodedIdToken: readIdToken(),
            renderloginPreference: true
        });

        Session.onExpiration((session) => this.onSessionExpires());
    }


    onSessionExpires() {
        const idamClientConfig = OAuthClientConfig;
        generateAuthUrlFromConfigForSilentAuth(idamClientConfig)
            .then((silentAuthzUrl) => {
                this._iFrameManager.loadSilentRenewIFrame(silentAuthzUrl);
                
                this._iFrameManager.removeIFrameOnTimeout('silent-renew-iframe');
            });

        Session.destroy('sessionLP');

    }


    onSilentAuthSuccess() {
        let accessToken = fetchTokenClaims(fetchAccessTokenFromLocal());
        this.startSessionMgmt(accessToken);
    }

    onSilentAuthError(e) {
        console.log("onSilentAuthError e.details: ", e.detail);
        //LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.msg_cannot_open']), "error", true);
        setTimeout(function () { window.location.reload() }, 3000);
    }

    render() {
        let props = this.props;

        if (this.state.renderloginPreference) {
            return (
                <div>
                    <SetLoginPreferences {...props}
                        idToken={this.state.idToken}
                        decodedIdToken={this.state.decodedIdToken}
                        clientId={OAuthClientConfig.client_id[props.userType.toLowerCase()]}
                        realmId={OAuthClientConfig.realm_id}
                    />
                </div>
            );
        }
        else {
            return (
                <LoginPrefsLoading {...props} />
            )
        }
    }
}

module.exports = injectIntl(LoginPreferences)